import { useContext, useEffect, useState } from "react";
import { Col, Container, Row, Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { AiOutlineBook, AiOutlineFile, AiOutlineFolder } from "react-icons/ai";
import { useParams } from "react-router-dom";
import UsuarioContext from "../../../../../context/userContext/context";
import { ButtonFavorite } from "../../../../components/button-favorite";
import { IMaterial } from "../../../../models/IMaterial";
import { detailDiscipline } from "../../../../services/discipline.service";
import { UnityAccordion } from "../components/unity-accordion";
import { CardBody, CardDescription, CardTitle } from "../../styled";
import { ButtonGoBack } from "../../components/button-go-back";
import { colors } from "../../../../../theme/theme";
import { removeFavorite } from "../../../../services/favorites.service";
import { toast } from "react-toastify";

export const DisciplineDetails = (): JSX.Element => {
	const { t: translation } = useTranslation();
	const { user } = useContext(UsuarioContext);

	const { id } = useParams<{ id: string }>();
	const [loading, setLoading] = useState(true);
	const [material, setMaterial] = useState<IMaterial>();

	useEffect(() => {
		if (id) {
			detailDiscipline(id).then((resp) => {
				let sortedResp = resp;
				if (resp && Array.isArray(resp.items)) {
					sortedResp = {
						...resp,
						items: resp.items.slice().sort((a: any, b: any) =>
							a.title.localeCompare(b.title, undefined, { numeric: true })
						),
					};
				}

				setMaterial(sortedResp);
				setLoading(false);
			});
		}
	}, [id]);

	const handleRemoveFavorite = (id: number) => {
		removeFavorite(id)
			.then(() => {
				toast.success("Disciplina removida com sucesso!", {
					position: "bottom-center",
				});
			})
			.catch((err: any) => {
				toast.error("Ocorreu um erro ao remover esta disciplina.");
			});
	};

	if (loading) {
		return (
			<div className="loading-container mt-5">
				<Spinner
					animation="border"
					variant="primary"
				/>
			</div>
		);
	}

	return (
		<Container fluid>
			<CardTitle color={colors.mainColors.blueberry}>
				<Row>
					<Col
						xs={10}
						lg={11}
						className="d-flex align-items-center"
					>
						<ButtonGoBack />
						{material?.title}
					</Col>
					<Col
						xs={2}
						lg={1}
					>
						{user.token && (
							<ButtonFavorite
								material={material}
								isMaterialView={false}
								variant="white"
								removeFavorite={handleRemoveFavorite}
							/>
						)}
					</Col>
				</Row>
			</CardTitle>
			<CardBody>
				<Row className="mt-3">
					<Col>
						<CardDescription>
							<Row>
								<Col>
									<div className="mb-3">
										<b>{translation("material.code")}: </b>{" "}
										{material?.code ||
											translation(
												"userAccount.uninformed"
											)}
									</div>
								</Col>
								<Col lg={2}>
									<div>
										<b>
											{translation("material.workload")}:{" "}
										</b>{" "}
										{!!material?.workload
											? material.workload + "h"
											: translation(
													"userAccount.uninformed"
											  )}
									</div>
								</Col>
								<Col>
									<div>
										<b>
											{translation(
												"components.card-news.knowledge"
											)}
											:{" "}
										</b>{" "}
										{!!material?.knowledge_area
											? material.knowledge_area.length > 1
												? material.knowledge_area[0]
														?.description + " +"
												: material.knowledge_area[0]
														?.description
											: translation(
													"userAccount.uninformed"
											  )}
									</div>
								</Col>
								<Col lg={2}>
									<div>
										<b>
											{translation(
												"components.card-news.Deadline"
											)}
											:{" "}
										</b>{" "}
										{material?.deadline
											? material.deadline > 1
												? "20 Dias"
												: "Pronta Entrega"
											: translation(
													"userAccount.uninformed"
											  )}
									</div>
								</Col>
							</Row>

							<Row>
								<Col>
									<div>
										<b>Nível de formação: </b>{" "}
										{material?.modalities?.length
											? material.modalities
													.map(
														(mod) =>
															mod
													)
													.join(", ")
											: null}
									</div>
								</Col>
							</Row>
						</CardDescription>
					</Col>
				</Row>

				<Row className="mt-3">
					<Col>
						<CardDescription>
							<div className="title mb-2">
								<AiOutlineFile
									fontSize={20}
									style={{ marginTop: "-5px" }}
								></AiOutlineFile>{" "}
								{translation("material.menuDiscipline")}
							</div>
							<div
								dangerouslySetInnerHTML={{
									__html:
										material?.description ||
										translation("userAccount.uninformed"),
								}}
							></div>
						</CardDescription>
					</Col>
				</Row>

				<Row className="mt-3">
					<Col>
						<CardDescription>
							<div className="title mb-3">
								<AiOutlineFolder
									fontSize={20}
									style={{ marginTop: "-5px" }}
								></AiOutlineFolder>{" "}
								{translation("material.units")}
							</div>
							{(() => {
								if (material?.items) {
									return (
										<UnityAccordion
											key={material.id}
											unities={material?.items}
										></UnityAccordion>
									);
								}

								return null;
							})()}

							{material?.items?.length === 0 ? (
								<h6>{translation("notFound.discipline")}</h6>
							) : (
								<></>
							)}
						</CardDescription>
					</Col>
				</Row>

				<Row className="mt-3">
					<Col>
						<CardDescription>
							<div className="title mb-3">
								<AiOutlineBook
									fontSize={20}
									style={{ marginTop: "-5px" }}
								></AiOutlineBook>{" "}
								{translation("material.bibliography")}
							</div>
							<div
								dangerouslySetInnerHTML={{
									__html:
										material?.reference ||
										translation("userAccount.uninformed"),
								}}
							></div>
						</CardDescription>
					</Col>
				</Row>
			</CardBody>
		</Container>
	);
};
